import { css, SerializedStyles } from '@emotion/react'
import { rwdrc2 } from '~/configs/rwdrc'

export const createMobileCss2 = (rootCss: SerializedStyles) =>
  css`
    @media screen and (max-width: ${rwdrc2.phone.max + 'px'}) {
      ${rootCss}
    }
  `
